export default {
  data: function(){return{
    searchTypeIndex: 0,
    emailAllowed: true,
    smsAllowed: false,
    searchFormat: 'email',
    invalidSMS: false,
    invalidEmail: false,
    currentPersona: {},
    invalidPersona: false
  }},  
  computed: {
    searchTypes: function() {
      let channels = [];

      if (this.uiConfig.sub_accounts) {
        this.emailAllowed = false
        this.smsAllowed = false
        if (this.activeSubAccount) {
          let activeChannels = this.activeSubAccount.channels;
          if ((activeChannels.email && activeChannels.email.active) || (activeChannels.dm && activeChannels.dm.active)) {
            this.emailAllowed = true
            channels.push ({
              value: 'email',
              displayName: 'Email',
              filterParameter: 'filterEmail'
            });
          }
          if (activeChannels.sms && activeChannels.sms.active) {
            this.smsAllowed = true
            channels.push ({
              value: 'sms',
              displayName: 'SMS',
              filterParameter: 'filterMobile'
            });
          }
        } else {
          let channelKeys = {}
          for (let subIdx in this.uiConfig.sub_accounts) {
            let activeChannels = this.uiConfig.sub_accounts[subIdx].channels;
            
            if ((activeChannels.email && activeChannels.email.active) || (activeChannels.dm && activeChannels.dm.active)) {
              this.emailAllowed = true
              channelKeys.email = {displayName: 'Email', filterParameter: 'filterEmail'};
            }
            if (activeChannels.sms && activeChannels.sms.active) {
              this.smsAllowed = true
              channelKeys.sms =  {displayName: 'SMS', filterParameter: 'filterMobile'};
            }
          }

          for (let key of Object.keys(channelKeys)) {
            channels.push ({
              value: key,
              displayName: channelKeys[key].displayName,
              filterParameter: channelKeys[key].filterParameter
            });
          }

        }

      } else {
        this.emailAllowed = true
        channels.push ({
          value: 'email',
          displayName: 'Email',
          filterParameter: 'filterEmail'
        });
      }

      return channels;
    },
    countryCodes: function() {
      if (this.uiConfig.country_codes) {
        return this.uiConfig.country_codes;
      } else {
        return [1,44]; // US, UK (always have default code be the first one in array)
      }
    },
    noPersona: function() {      
      return Boolean(!this.currentPersona.lookup_email);
    }
  },
  methods: {
    setFilterEmail(e){
      this.$store.commit("setFilterEmail",e.target.value);
    },
    setFilterMobile(e){
      this.$store.commit("setFilterMobile",e.target.value);
    },
    focusControl(controlId) {
      $(`#${controlId}`).focus();
      $(`#${controlId}`).select();
    },
    validateSearchInput(inputVal) {
      if (this.emailAllowed) {
        if (this.validateEmail(inputVal)) {
          this.invalidEmail = false
          this.searchFormat = 'email'
          return true
        } else if (this.smsAllowed && this.validateMobileNumber(inputVal)) {
          this.invalidEmail = false
          this.searchFormat = 'sms'
          return true
        } else {
          this.invalidEmail = true
          this.searchFormat = 'email'
          return false
        }
      }
    },
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let passed = re.test(email);
      if (!passed) {
        this.invalidEmail = true;
      } else {
        this.invalidEmail = false;
      }
      return passed
    },
    validateMobileNumber(num) {
      let hasCountryCode = false;

      //console.log(num.replace(/[ \-()\.]/g, ''));
      num = num.replace(/[ \-()\.]/g, '');

      if (num.trim().substr(0,1)=="+") {
        num = num.trim().substr(1);
      }

      // check if country code has already been included
      for (let code of this.countryCodes) {
        if (num.trim().substr(0,code.toString().length)==code) {
          hasCountryCode = true;
          break;
        }
      }

      // confirm if we have a valid mobile number
      // TODO: replace with specific masks for countries we will support
      var phoneMasks = /^\+?((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[013-9]|3[0-469]|2[70]|7|1)(?:\W*\d){0,13}\d$/;
      if(num.toString().match(phoneMasks)) {
        // add default country code if not already added
        if (!hasCountryCode) {
          num = this.countryCodes[0].toString() + num.trim();
        }
        //this.$store.commit("setFilterMobile",'+' + num.trim())
        $('#email_lookup').val('+' + num.trim());
        this.$store.commit("setFilterMobile",'+' + num.trim().replace(/\D/g, ''));
        //console.log("Cleaned up phone format: " + this.search.filterMobile);
        this.invalidSMS = false;
        return true;
      } else {
        this.invalidSMS = true;
        return false;
      }
    }
  },
  watch: {
    filterEmail(newVal) {
      if (!newVal) {
        this.searchFormat = "email" 
      }
    },
    currentPersona: function(newVal) {
      if (newVal.lookup_email) {
        this.invalidPersona = false;  
      }
    }
  }
}